import axios from "axios";
import tiposConsulta from "./emuns/tiposConsulta";

/**
 * @param {Object} payload
 * @param {Date} payload.startDate
 * @param {Date} payload.endDate
 * @param {String} payload.canal
 * @param {String} payload.type
 * @returns {Promise}
 *
 * Realiza un request para solicitar los datos del gráfico mensual
 */
export default function getGraficoMensualData({ startDate, endDate, canal, type }) {
  return new Promise((resolve, reject) => {
    axios.post(serverRoutes.consultaServicios, {
      fecha_inicio: startDate,
      fecha_termino: endDate,
      canal,
      tipo: type,
      tipo_consulta: tiposConsulta.mensual,
    }).then((response) => {
      const { data } = response;

        if (type == 'encuestas') {
            resolve(data )
        }
      const [kpisData, graficoData] = data;

      const totales = getTotalesFormateadosByKPis(kpisData.KPIs);

      if(Array.isArray(graficoData)) {
        const [grafico1Data, grafico2Data] = graficoData
        const [titulos, titulos2] = getTitulosByType(type);
        const series = grafico1Data.series.map(serie => {
          return {
            ...serie,
            group: serie.type,
          }
        })
        const labels = grafico1Data.labels
        const series2 = grafico2Data.series.map(serie => {
          return {
            ...serie,
            group: serie.type,
          }
        })
        const labels2 = grafico2Data.labels
        resolve({ totales, series, labels, titulos, series2, labels2, titulos2 })
      }


      const series = graficoData.series.map(serie => {
        return {
          ...serie,
          group: serie.type,
        }
      })
      const labels = graficoData.labels
      const titulos = getTitulosByType(type);
      resolve({totales, series, labels, titulos })
     }).catch((err) => {
        reject(err);
     })
    })
}

function getTotalesFormateadosByKPis(kpis) {
  return kpis.map((kpi) => {
    if(kpi.graficoTorta) {
      return {
        ...kpi,
        graficoTorta: kpi.graficoTorta.map((item) => ({
          ...item,
          value: Number(item.value.replace('%', '')),
        }))
      };
    }
    return kpi;
  })
}

function getTitulosByType(type) {
    switch (type) {
        case "conversaciones":
            return [
                'Gráfico mensual (Volumen)',
                'Cantidades de conversaciones por (xCanal) (Barra)',
                'Cantidades de conv por agente (xCanal) (Línea)'
            ];
        case "intent":
            return [
                'Gráfico mensual (Efectividad)',
                'Cantidad de mensajes por Canal',
                '% Intent detectados y no x Canal'
            ];
        case "agentes":
            return [
                'Gráfico mensual (Efectividad)',
                'Cantidades de conversaciones por canal',
                'Tiempo prom por conversación'
            ];
        case "flujos":
            return [
                [
                    'Gráfico mensual (Reembolso)',
                    'Cantidad de intentos de reembolsos (xCanal)',
                    '% Efectividad (xCanal)',
                ],
                [
                    'Gráfico mensual (Lead)',
                    'Cantidad de intentos de Lead (xCanal)',
                    '% Efectividad (xCanal)',
                ]
            ];
        default:
            return [
            ];
    }
}
